import { GET_ORDER_PAYMENT_INFO } from '../actionTypes/OrderActionTypes';

export default function OrderPaymentInfoReducer(state = [], action) {
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case GET_ORDER_PAYMENT_INFO:
            return action.payload;
        default:
            return state;
    }
}
